<template>
  <TemplatesContentfulExpertAnalysis />
</template>

<script setup>
defineOptions({
  name: 'ExpertAnalysisPostPage'
})
</script>
